import { render, staticRenderFns } from "./SysMemberCoupon.vue?vue&type=template&id=6135554e&scoped=true"
import script from "./SysMemberCoupon.vue?vue&type=script&lang=js"
export * from "./SysMemberCoupon.vue?vue&type=script&lang=js"
import style0 from "./SysMemberCoupon.vue?vue&type=style&index=0&id=6135554e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135554e",
  null
  
)

export default component.exports